import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';

import {
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { PinIcon } from '../customIcons';
import { fetchPins, selectPinsByOwner, removePin } from '../pins/pinsSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 3, 0)
  },
  title: {
    margin: theme.spacing(0, 3, 0, 3)
  },
  listItem: {
    backgroundColor: theme.palette.primary[600],
    color: '#ffffff',
    '& .MuiListItemIcon-root, & .MuiListItemText-secondary': {
      color: 'currentColor'
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: theme.palette.primary[500]
    },
    '&.MuiListItem-divider': {
      borderColor: theme.palette.primary[700]
    }
  },
  removeIcon: {
    color: '#ffffff'
  }
}));

const makePinLink = (item) => {
  if(item.itemType === 'item') {
    return `/pih/owner/${item.itemOwner}/items/${item.itemCode}`;
  } else if(item.itemType === 'itemFamily') {
    return `/pih/owner/${item.itemOwner}/families/${item.itemCode}`;
  } else if(item.itemType === 'wheel') {
    return `/pih/owner/${item.itemOwner}/wheels/${item.itemCode}`;
  } else if(item.itemType === 'tread') {
    return `/pih/owner/${item.itemOwner}/treads/${item.itemCode}`;
  } else if(item.itemType === 'tread-item') {
    return `/pih/owner/${item.itemOwner}/tread-item/${item.itemCode}`;
  } else {
    return '/404';
  }
};

const PinList = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { status, pins } = useSelector(selectPinsByOwner);
  const dispatch = useDispatch();

  useEffect(() => {
    if(status === 'idle') {
      dispatch(fetchPins());
    }
  }, [status]);

  const pinsWithRouterLink = pins.map(pin => ({
    ...pin,
    path: makePinLink(pin)
  }));

  const handleRemove = pinId => {
    dispatch(removePin(pinId));
  };

  const isActivePin = (routeName) => {
    return window.location.hash.indexOf(routeName) > -1 ? true : false;
  }

  return (
    <div className={classes.root} {...props}>
      <Typography variant="overline" className={classes.title} >{t('pins:pinnedItems')}</Typography>
      <List>
        {pinsWithRouterLink.map(pin =>
          <ListItem className={classes.listItem} key={`${pin.itemOwner}${pin.itemCode}`} selected={isActivePin(pin.path)} divider component={NavLink} to={pin.path}>

            <ListItemIcon>
              <PinIcon />
            </ListItemIcon>
            <ListItemText
              primary={pin.itemName}
              secondary={pin.itemType === 'item' ? pin.itemCode : undefined}
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label={t('pins:unpin')} title={t('pins:unpin')} className={classes.removeIcon} onClick={() => handleRemove(pin.id)}>
                <CloseIcon />
              </IconButton>
            </ListItemSecondaryAction>

          </ListItem>
        )}
      </List>
    </div>
  );
};

export default PinList;
